import React from 'react';
import { Plus } from 'lucide-react';
import EditableColumnHeader from './EditableColumnHeader';
import TaskItem from './TaskItem';
import Button from './Button';
import Input from './Input';
import { filterItems, getInitiativesCount } from './utils';

const TaskColumn = ({
  type,
  items,
  selectedId,
  setSelectedId,
  newItemText,
  setNewItemText,
  addItem,
  toggleCompletion,
  columnHeaders,
  setColumnHeaders,
  headerKey,
  openMenuId,
  setOpenMenuId,
  openSubmenuId,
  setOpenSubmenuId,
  deleteItem,
  setPriority,
  goalId,
  stepId,
  taskId,
  filterState,
  editingItemId,
  setEditingItemId,
  editingText,
  setEditingText,
  updateItemTitle,
  draggedItem,
  handleDragStart,
  handleDragOver,
  handleDrop,
  isDisabled = false
}) => {
  return (
    <div className="w-1/4 border-r flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <EditableColumnHeader 
          headerKey={headerKey} 
          value={columnHeaders[headerKey]} 
          setColumnHeaders={setColumnHeaders}
        />
      </div>

      <div className="overflow-y-auto flex-1">
        {items && filterItems(items, filterState).map((item) => (
          <TaskItem
            key={item.id}
            item={item}
            type={type}
            isSelected={selectedId === item.id}
            onClick={() => setSelectedId(item.id === selectedId ? null : item.id)}
            onToggleCompletion={toggleCompletion}
            draggedItem={draggedItem}
            handleDragStart={handleDragStart}
            handleDragOver={handleDragOver}
            handleDrop={handleDrop}
            openMenuId={openMenuId}
            setOpenMenuId={setOpenMenuId}
            openSubmenuId={openSubmenuId}
            setOpenSubmenuId={setOpenSubmenuId}
            deleteItem={deleteItem}
            setPriority={setPriority}
            goalId={goalId}
            stepId={stepId}
            taskId={taskId}
            editingItemId={editingItemId}
            setEditingItemId={setEditingItemId}
            editingText={editingText}
            setEditingText={setEditingText}
            updateItemTitle={updateItemTitle}
            childCount={type === 'task' ? getInitiativesCount(item) : item[type === 'goal' ? 'steps' : 'tasks']?.length}
          />
        ))}

        <div className="p-4 flex items-center border-b">
          <Button
            variant="icon"
            onClick={() => !isDisabled && addItem()}
            disabled={isDisabled}
            icon={Plus}
            className="mr-2"
          />
          <Input
            className="flex-1"
            placeholder={`New ${type}`}
            value={newItemText}
            onChange={(e) => setNewItemText(e.target.value)}
            onKeyPress={(e) => !isDisabled && e.key === 'Enter' && addItem()}
            disabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskColumn; 